import { useMemo } from 'react'
import AlertContainer from './AlertContainer'
import { useTranslation } from 'react-i18next'
import { Group, Loader, Text } from '@mantine/core'

const CheckingSyncAlert = () => {
  const { t } = useTranslation('others')

  const alertText = useMemo(() => {
    return (
      <Group gap="md" justify="center">
        <Text fz="var(--spacing-xl)" ta="center" c="white">
          {t('checkingSync')}
        </Text>
        <Loader size="md" color="white" />
      </Group>
    )
  }, [t])

  return <AlertContainer type="alert" alertText={alertText} alertColor="teal" height="small" />
}

export default CheckingSyncAlert
